import { Action } from '@ngrx/store';

export class PlatformsAcceptanceAction implements Action {

    public static getDataTransferAcceptance = '[Platforms Acceptance] get_data_transfer_acceptance';
    public static getDataTransferAcceptanceError = '[Platforms Acceptance] get_data_transfer_acceptance_error';
    public static getDataTransferAcceptanceSuccess = '[Platforms Acceptance] get_data_transfer_acceptance_success';

    public static setDataTransferAcceptance = '[Platforms Acceptance] set_data_transfer_acceptance';
    public static setDataTransferAcceptanceError = '[Platforms Acceptance] set_data_transfer_acceptance_error';
    public static setDataTransferAcceptanceSuccess = '[Platforms Acceptance] set_data_transfer_acceptance_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
